import React, { useEffect, useState, useRef } from "react";
import classNames from "classnames";
import Picker from "../Picker/Picker";
import { getOtherProperties } from "../common/Utils";
import { DateData, DatetimePickerProps } from "./PropsType";

// const dateArray: string[] = ["年", "月", "日"];

export default function DatetimePicker(props: DatetimePickerProps) {
  const {
    minDate = "2000/1/1",
    maxDate = "2020/1/1",
    className,
    onClose,
    onOpen,
    mode = "date",
    ...other
  } = props;
  const [data, setData] = useState([]);
  const [value, setValue] = useState("");
  const [visible, setVisible] = useState(false);
  const styleClass = classNames("DatetimePicker", className);
  const otherProps: any = getOtherProperties(other, [
    "defaultValue",
    "children",
    "minDate",
    "maxDate",
    "onOk",
    "onOpen",
    "onValueChange",
    "visible",
  ]);

  const miniDate = useRef<any>({
    minDate: [],
    maxDate: []
  });
  const values = useRef<DateData[]>([]);

  const getRangeOfDate = () => {
    return {
      minDate: splitDate(minDate),
      maxDate: splitDate(maxDate),
    };
  };

  const splitDate = (value: any) => {
    let data = [...value];
    if (typeof value === "string") {
      data = value.split(/\/|-/gm).map((v: string) => {
        return +v;
      });
    } else {
      data = [+value.getFullYear(), +value.getMonth() + 1, +value.getDate()];
    }
    return data;
  };

  const countDay = (year: number, month: number) => {
    const lists: any[] = [];
    const num = getDay(year, month).total;
    for (let i = 1; i < num + 1; i++) {
      const value = dateEncode(i);
      lists.push({
        label: value,
        value: i,
      });
    }
    return lists;
  };

  const getInitDate = () => {
    const curDate = new Date();
    const defaultValue = props.defaultValue;
    const year: any = curDate.getFullYear(),
      month: any = curDate.getMonth() + 1,
      date: any = curDate.getDate();
    const value: any[] = defaultValue
      ? splitDate(defaultValue)
      : [year, month, date];
    values.current = (values.current || value).map((v: any) => {
      const label = v.label || v;
      const newValue = v.value || v;
      return {
        label: dateEncode(label),
        value: newValue,
      };
    });
    const yearValue: number = parseInt(value[0], 10);
    values.current[0] = {
      value: values.current[0] ? values.current[0].value : yearValue,
      label: values.current[0] ? values.current[0].label : yearValue,
    };
    return countDay(values.current[0]?.value, values.current[1]?.value);
  };

  const getDay = (year: any, month: any) => {
    const curDate = new Date();
    curDate.setFullYear(year);
    curDate.setMonth(month);
    curDate.setDate(0);
    const total = curDate.getDate();
    curDate.setDate(1);
    let day = curDate.getDay();
    if (day === 0) {
      day = 7;
    }
    return {
      total,
      day,
    };
  };

  const getDate = () => {
    const days: any[] = getInitDate();
    const lists: any = [...data!];
    for (let i = 0; i < miniDate.current.maxDate[0] - miniDate.current.minDate[0] + 1; i++) {
      const children: any = (lists[i] && lists[i].children) || [];
      const year = i + miniDate.current.minDate[0];
      if (year === parseInt(values.current[0]?.value, 10)) {
        for (let j = 1; j < 13; j++) {
          const month = j - 1;
          let child: any[] =
            (children[month] && children[month].children) || [];
          const s = values.current[1]?.value;
          if (j === s) {
            child = days;
          }
          children[month] = {
            label: dateEncode(j),
            value: j,
            children: child,
          };
        }
      }
      lists[i] = {
        label: year,
        value: year,
        children,
      };
    }
    return lists;
  };

  const dateEncode = (d: any) => {
    d = parseInt(d, 10) >= 10 ? d : "0" + parseInt(d, 10);
    return d;
  };

  const dateDecode = (d: any) => {
    return parseInt(String(d.value).replace(/\b(0+)/gi, ""), 10);
  };

  const handleValueChange = (event: any) => {
    values.current[event.index] = event.value;
    const data: any = getDate();
    setData(data);
  };

  const handleChange = (value: any) => {
    setValue(value);
    if (props.onOk) {
      props.onOk(value);
    }
  };

  useEffect(() => {
    miniDate.current = getRangeOfDate();
    setVisible(!!props.visible);
    setData(getDate());
  }, []);

  useEffect(() => {
    setVisible(!!props.visible);
    setData(getDate());
  }, [props.visible]);

  return (
    <div className={styleClass} {...otherProps}>
      <Picker
        data={data}
        defaultValue={values.current}
        value={value}
        onValueChange={handleValueChange}
        visible={visible}
        onChange={handleChange}
        onOpen={onOpen}
        onClose={onClose}
      />
    </div>
  );
}
